/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './UploadWrapper.module.css';

const UploadWrapper = ({
  children, className, name, ...props
}) => (
  <label htmlFor={name} className={cn([className, style.handle])}>
    {children}
    <input id={name} name={name} type="file" className={style.input} {...props} />
  </label>
);

UploadWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

UploadWrapper.defaultProps = {
  className: null,
};

export default UploadWrapper;
